import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "16_event-ok.svg",
  "use": "16_event-ok.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"16_event-ok.svg\"><rect width=\"16\" height=\"16\" transform=\"translate(0 16) rotate(-90)\" style=\"fill:none\" /><circle cx=\"7.5\" cy=\"7.5\" r=\"7\" style=\"fill:#fafafa;stroke:#18ab50;stroke-miterlimit:10\" /><polyline points=\"5.01 7.59 6.61 9.19 9.99 5.81\" style=\"fill:none;stroke:#18ab50;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol